import { Text, VStack } from '@chakra-ui/react';

import { PhotoEntry } from '../photos/buildPhotoSlotMap';
import PhotoSlot from '../photos/components/PhotoSlot';
import { SlotDefinition } from '../photos/constants';

type PrelistCaptureColumnProps = {
  slot: SlotDefinition;
  photo: PhotoEntry | undefined;
  isProcessing: boolean;
  caption?: string;
  locked?: boolean;
  onClick: () => void;
  onView: () => void;
  onDelete: () => void;
  onFileDrop: (file: File) => void;
};

const PrelistCaptureColumn = ({
  slot,
  photo,
  isProcessing,
  caption,
  locked = false,
  onClick,
  onView,
  onDelete,
  onFileDrop,
}: PrelistCaptureColumnProps) => (
  <VStack spacing={1.5} align="stretch">
    <PhotoSlot
      slot={slot}
      photo={photo}
      isProcessing={isProcessing}
      isPulsing={false}
      onClick={onClick}
      onViewPhoto={() => {
        // Locked (already on the DD deal) stays inert: the lightbox offers
        // replace/delete, which don't apply to it.
        if (!locked && photo?.previewUrl) onView();
      }}
      onDelete={onDelete}
      onFileDrop={(file) => {
        if (!locked) onFileDrop(file);
      }}
      slotRef={() => undefined}
      isPostAcceptance={locked}
    />
    {caption && (
      <Text fontSize="xs" color="grayLight" textAlign="center">
        {caption}
      </Text>
    )}
  </VStack>
);

export default PrelistCaptureColumn;
